export default __webpack_public_path__ + "static/media/tabula-mobile-4.66f49fdb.png";